import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from "primeng/multiselect";

import { CoreModule } from '../../core/core.module';
import { DepartmentListDetailComponent } from './department-list-detail/department-list-detail.component';
import { DepartmentListComponent } from './department-list/department-list.component';
import { DepartmentRoutingModule } from './department-routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    DropdownModule,
    DepartmentRoutingModule,
    NgbModule,
    ModalModule.forRoot(),
    CoreModule,
    TranslateModule,
    MultiSelectModule,
    ReactiveFormsModule,
  ],
  declarations: [
    DepartmentListComponent,
    DepartmentListDetailComponent
  ]
})
export class DepartmentModule { }



// WEBPACK FOOTER //
// /opt/app/src/app/features/department/department.module.ts